import { Box, Link, Typography } from '@mui/material';

/**
 * Empty-state overlay for the Projects table — only renders the "No matches
 * for X. Clear search" hint when a search is actively filtering. The
 * no-search case (truly zero projects) renders nothing on purpose:
 * Create Project lives in the toolbar, the message is rarely useful, and
 * suppressing it avoids the flash between data sets.
 */
const ProjectsEmptyOverlay = (props) => {
  // Don't render anything while the table is between data sets — search
  // input changed but the debounce/fetch hasn't caught up.
  if (props?.isSearchTransitioning) {
    return null;
  }

  const trimmed = (props?.search || '').trim();
  if (!trimmed) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        gap: 1.5,
        py: 6,
        px: 2,
        textAlign: 'center',
        color: 'text.secondary',
      }}
    >
      <Typography variant="body2">
        No matches for &ldquo;{trimmed}&rdquo;.{' '}
        {props?.onClearSearch && (
          <Link
            component="button"
            type="button"
            underline="hover"
            onClick={props.onClearSearch}
            sx={{
              verticalAlign: 'baseline',
              '&:hover': { backgroundColor: 'transparent' },
              '&:focus': { backgroundColor: 'transparent' },
            }}
          >
            Clear search
          </Link>
        )}
      </Typography>
    </Box>
  );
};

export default ProjectsEmptyOverlay;
